import { render } from "./Vbots.vue?vue&type=template&id=4ebc71b4&scoped=true"
import script from "./Vbots.vue?vue&type=script&lang=js"
export * from "./Vbots.vue?vue&type=script&lang=js"

import "./Vbots.vue?vue&type=style&index=0&id=4ebc71b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebc71b4"]])

export default __exports__